import React from 'react';
import classnames from 'classnames';
import range from 'lodash/range';
import { useTranslation } from 'react-i18next';
import InputLayout from '../../InputLayout';
import NumbersDropdown from '../NumbersDropdown';
import s from './DateDropdowns.scss';
const DateDropdowns = (props)=>{
    const { t } = useTranslation();
    const { namePrefix, monthValue, dayValue, yearValue, className, textUnderClassName, dropdownFieldClassName, label, onSelect, errorMessage, forceNativeDropdown = true } = props;
    const days = range(1, 32).map((day)=>({
            value: day,
            label: day
        }));
    const months = range(1, 13).map((month)=>({
            value: month,
            label: t(`date.month.${month}`)
        }));
    // UTC so new years eve doesn't cause SSR errors
    const currentYear = new Date().getUTCFullYear();
    // In case a current-day Jeanne Clement wants to use the site
    const years = range(currentYear, currentYear - 123, -1).map((year)=>({
            value: year,
            label: year
        }));
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement(InputLayout, {
        label: label,
        className: classnames(s['month'], dropdownFieldClassName),
        textUnderClassName: textUnderClassName,
        isFilled: true,
        isFocused: false,
        hasError: !!errorMessage,
        errorMessage: errorMessage
    }, /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: `${namePrefix}Month`,
        value: monthValue
    }), /*#__PURE__*/ React.createElement(NumbersDropdown, {
        "aria-label": t('datedropdown.month'),
        placeholder: "Month",
        items: months,
        selectedValue: monthValue || '',
        onSelect: (value)=>onSelect && onSelect('month', value),
        forceNativeDropdown: forceNativeDropdown
    })), /*#__PURE__*/ React.createElement(InputLayout, {
        className: dropdownFieldClassName,
        isFilled: true,
        isFocused: false
    }, /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: `${namePrefix}Day`,
        value: dayValue
    }), /*#__PURE__*/ React.createElement(NumbersDropdown, {
        "aria-label": t('datedropdown.day'),
        placeholder: "Day",
        items: days,
        selectedValue: dayValue,
        onSelect: (value)=>onSelect && onSelect('day', value),
        forceNativeDropdown: forceNativeDropdown
    })), /*#__PURE__*/ React.createElement(InputLayout, {
        className: dropdownFieldClassName,
        isFilled: true,
        isFocused: false
    }, /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: `${namePrefix}Year`,
        value: yearValue
    }), /*#__PURE__*/ React.createElement(NumbersDropdown, {
        "aria-label": t('datedropdown.year'),
        placeholder: "Year",
        items: years,
        selectedValue: yearValue,
        onSelect: (value)=>onSelect && onSelect('year', value),
        forceNativeDropdown: forceNativeDropdown
    })));
};
DateDropdowns.displayName = 'DateDropdowns';
export default DateDropdowns;

//# sourceMappingURL=DateDropdowns.js.map